export const getErrorMessageForAssessmentFiles = ({
  errorCodes,
  maxFileSizeMB = 10,
  errorMessage = {
    'file-invalid-type': '',
    'too-many-files': '',
    'file-too-large': '',
  },
}) => {
  const errorMessages = [];
  if (errorCodes?.includes('file-invalid-type')) {
    errorMessages.push(
      errorMessage?.['file-invalid-type'] ||
        'Some of the selected files are not supported. Try compressing and uploading them as a zip file.'
    );
  }
  if (errorCodes?.includes('too-many-files')) {
    errorMessages.push(
      errorMessage?.['too-many-files'] ||
        `You can upload a maximum of 10 files at a time. To upload more, try compressing and uploading as a zip file.`
    );
  }
  if (errorCodes?.includes('file-too-large')) {
    const sizeText = maxFileSizeMB >= 1024 
      ? `${maxFileSizeMB / 1024} GB` 
      : `${maxFileSizeMB} MB`;
    errorMessages.push(
      errorMessage?.['file-too-large'] ||
        `You can upload files up to ${sizeText} in size. Try compressing and uploading larger files as a zip file.`
    );
  }
  return errorMessages;
};
